<template>
    <v-container>
        <v-lov-dialog title="选择权限组" :width="800"
                      :fields="permissionLovFields"
                      query-api="PERMISSION_QUERY"
                      v-model="showPermissionLovDialog"
                      @cancel="showPermissionLovDialog=false"
                      @ok="onSelectPermission"></v-lov-dialog>
        <v-simple-form title="用户信息">
            <template v-slot:toolbar>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
                    <v-icon color="gray">mdi-step-backward</v-icon>
                    返回
                </v-btn>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="onSave">
                    <v-icon color="gray">mdi-content-save</v-icon>
                    保存
                </v-btn>
                <v-spacer/>
            </template>
            <template v-slot:content>
                <v-form-field x-large v-model="dataItem.name" label="名称"></v-form-field>
                <v-form-field x-large v-model="dataItem.path" label="路径"></v-form-field>
                <v-form-selector x-large v-model="dataItem.method" label="方法"
                                 items="GET|GET,POST|POST,PUT|PUT,DELETE|DELETE,PATCH|PATCH"></v-form-selector>
                <v-form-selector x-large v-model="dataItem.protectLevel" label="保护级别"
                                 items="公开|PUBLIC,保护|PROTECT"></v-form-selector>
                <v-form-field x-large v-model="dataItem.permissionName" label="权限组">
                    <template v-slot:append>
                        <v-btn icon small @click="showPermissionLovDialog=true">
                            <v-icon>mdi-database-search</v-icon>
                        </v-btn>
                    </template>
                </v-form-field>
                <v-form-textarea x-large v-model="dataItem.clazz" label="java类路径"></v-form-textarea>
                <v-form-textarea x-large v-model="dataItem.description" label="说明"></v-form-textarea>
            </template>
        </v-simple-form>
    </v-container>
</template>

<script>

    import PermissionLovFields from "./fields/FndPermissionLov";

    export default {
        name: "FndMenuDetail.vue",
        data() {
            return {
                docId: null,
                permissionLovFields: PermissionLovFields,
                showPermissionLovDialog: false,
                dataItem: {
                    id: null,
                    name: null,
                    clazz: null,
                    method: null,
                    protectLevel: null,
                    path: null,
                    permissionName: null,
                    permissionId: null,
                    ext: null
                }
            }
        },
        created() {
            this.docId = this.$route.query.id;
            if (this.docId) {
                this.queryDetail(this.docId);
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            onSave() {
                this.$request
                    .request("REST_APPLY", this.dataItem)
                    .then((response) => {
                        this.$message.success("保存成功");
                    });
            },

            queryDetail(id) {
                this.$request
                    .request("REST_DETAIL", {rowid: id})
                    .then(response => {
                        this.dataItem = Object.assign(this.dataItem, response.data)
                    });
            },
            onSelectPermission(val) {
                this.dataItem.permissionId = val.id;
                this.dataItem.permissionName = val.name;
                this.showPermissionLovDialog = false;
                console.log(this.data.dataItem)
            }
        }
    }
</script>
